<template>
  <div v-loading="loading">
    <Form>
      <Row>
        <Col span="12">
          <FormItem :label="l('SHENQINGZHUTI')">{{item.topic}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('XUEFEN')">{{item.credit}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('KESHI')">{{item.hour}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('JIFEN')">{{item.integral}}</FormItem>
        </Col>
      </Row>
      <Row v-if="item.fileName">
        <Col span="24">
          <FormItem :label="l('FUJIAN')">
            <Button
              type="primary"
              size="small"
              @click="handleDownload(item)">{{l('XIAZAI')}}</Button>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="l('SHENQINGSHUOMING')">{{item.description}}</FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import { AppConsts } from "cf/packages/abpVue/AppConsts";
export default {
  name: "hourCreditIntegralAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    handleDownload(item) {
      GUtil.download(
        AppConsts.remoteServiceBaseUrl +
          "/sys/file/downloadFile?fileName=" +
          item.fileName +
          "&serverId=" +
          item.serverId +
          "&downloadFileName=" +
          window.encodeURI(this.l("FUJIAN"))
      );
    },
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("user/sysHourCreditIntegralApply/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// hourCreditIntegralAudit.vue?3597351c